import React, { useState } from 'react';
import { Grid, Card } from '@material-ui/core';
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  ImageField,
  ImageInput,
  AutocompleteInput,
  ReferenceInput,
  required,
  maxLength,
} from 'react-admin';
import Toolbar from '../resource-toolbar';
import WithTooltip from '../with-tooltip';
import { LanguageChanger } from '../fields';
import { useServerValidation, useLanguageChange, getStyle } from '../../helpers';
import { HOST_TYPES, LANGUAGES, PRICE_TIER, LICENSE_TYPES } from '../../constants';

const Title = ({ record }) => `Host #${record.id}. ${record.name}`;

const WithProps = ({ children, ...props }) => children(props);

export default (props) => {
  const [record, setRecord] = useState(null);
  const { onFailure } = useServerValidation();
  const [defaultLanguage] = LANGUAGES;
  const { language, onLanguageChange } = useLanguageChange(defaultLanguage);
  return (
    <Grid container spacing={2}>
      <Grid item lg={6} md={8} xs={12}>
        <Edit {...props} onFailure={onFailure} undoable={false} title={<Title />}>
          <SimpleForm toolbar={<Toolbar resourceName="hosts" />}>
            <WithProps>
              {({ record }) => {
                setRecord(record);
                return null;
              }}
            </WithProps>
            <TextInput source="name" label="Host Name" fullWidth validate={[required(), maxLength(255)]} />
            <SelectInput
              source="type"
              translateChoice={false}
              choices={HOST_TYPES}
              fullWidth
              validate={required()}
            />
            <WithTooltip tooltipText="Allowed formats: JPG, PNG">
              <ImageInput source="files" label="Photo" accept="image/jpeg, image/png">
                <ImageField source="photo_url" title="Host Photo" />
              </ImageInput>
            </WithTooltip>
            <ReferenceInput
              source="address"
              reference="places"
              fullWidth
              validate={required()}
            >
              <AutocompleteInput 
                optionText="name" 
                matchSuggestion={() => true}
              />
            </ReferenceInput>
            <TextInput source="phone" fullWidth />
            <TextInput source="url" fullWidth />
            <TextInput source="hashtag" fullWidth />
            {(props.permissions === 'MASTER_ADMIN' || props.permissions === 'ADMIN') && (
            <SelectInput
              source="price_tier"
              translateChoice={false}
              choices={PRICE_TIER}
              fullWidth
            />)}
            {(props.permissions === 'MASTER_ADMIN' || props.permissions === 'ADMIN') && (
            <SelectInput
              source="license_type"
              translateChoice={false}
              choices={LICENSE_TYPES}
              fullWidth
              defaultValue="Paid"
              validate={required()}
            />)}
            <LanguageChanger language={language} onLanguageChange={onLanguageChange} />
            <TextInput style={getStyle(language, '_en')} rows="5" multiline source="description" fullWidth validate={maxLength(10000)} />
            <TextInput style={getStyle(language, '_fr')} rows="5" multiline source="description_fr" fullWidth validate={maxLength(10000)} />
            <TextInput style={getStyle(language, '_jp')} rows="5" multiline source="description_jp" fullWidth validate={maxLength(10000)} />
            <TextInput style={getStyle(language, '_cn')} rows="5" multiline source="description_cn" fullWidth validate={maxLength(10000)} />
            <TextInput style={getStyle(language, '_de')} rows="5" multiline source="description_de" fullWidth validate={maxLength(10000)} />
            <TextInput style={getStyle(language, '_kr')} rows="5" multiline source="description_kr" fullWidth validate={maxLength(10000)} />
            <TextInput style={getStyle(language, '_es')} rows="5" multiline source="description_es" fullWidth validate={maxLength(10000)} />
          </SimpleForm>
        </Edit>
      </Grid>
      <Grid item lg={6} md={4} xs={12}>
        {record && (
          <Card style={{ marginBottom: '2.5em', marginTop: '1em' }}>
            <img src={record.photo_url} width="100%" alt="Preview" />
          </Card>
        )}
      </Grid>
    </Grid>
  );
};
